import { Product } from "../../types/store";

export const featuredProducts: Product[] = [
    {
        id: "texture-aurora",
        name: "Aurora Texture Lab Vol. 03",
        type: "TEXTURE",
        thumbnailUrl: "https://images.unsplash.com/photo-1526318896980-cf78c088247c?auto=format&fit=crop&w=800&q=80",
        description: "Neon-lit cyber surfaces with calibrated PBR maps.",
        price: 49,
        tags: ["PBR", "4K", "Cyberpunk"],
        meta: {
            texturesCount: 32,
            resolution: "4K"
        }
    },
    {
        id: "stl-mech",
        name: "Mech Titan STL Bundle",
        type: "STL",
        thumbnailUrl: "https://images.unsplash.com/photo-1526045478516-99145907023c?auto=format&fit=crop&w=800&q=80",
        description: "6 kitbash-friendly mech units ready for resin printing.",
        price: 69,
        tags: ["STL", "Hard Surface"],
        meta: {
            stlCount: 6,
            printTimeEstimateHours: 42
        }
    },
    {
        id: "physical-rig",
        name: "Concept Sculpt Resin Figure",
        type: "PHYSICAL",
        thumbnailUrl: "https://images.unsplash.com/photo-1501426026826-31c667bdf23d?auto=format&fit=crop&w=800&q=80",
        description: "Hand-finished collectible printed in-house.",
        price: 189,
        tags: ["Collector", "Limited"],
        meta: {
            printTimeEstimateHours: 18
        }
    },
    {
        id: "figur-lab",
        name: "Figur Lab Custom Hero",
        type: "FIGUR_LAB",
        thumbnailUrl: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80",
        description: "Commission a bespoke character sculpt based on your prompts.",
        price: 390,
        tags: ["Custom", "Premium"],
        meta: {
            printTimeEstimateHours: 24
        }
    }
];
